import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export function MemorySuggestions({ category, onSelect, currentValue = '', className = '' }) {
    const [suggestions, setSuggestions] = useState([]);
    const [show, setShow] = useState(false);

    useEffect(() => {
        loadSuggestions();
    }, [category]);

    const loadSuggestions = async () => {
        try {
            const res = await axios.get(`${API}/api/favorites/memory/${category}`);
            setSuggestions(res.data?.suggestions || []);
        } catch (e) {}
    };

    // Filter suggestions based on current input
    const filtered = currentValue 
        ? suggestions.filter(s => s.name?.toLowerCase().includes(currentValue.toLowerCase()))
        : suggestions;

    if (filtered.length === 0) return null;

    return (
        <div className={`flex gap-1.5 flex-wrap ${className}`}>
            {filtered.slice(0, 6).map((s, i) => (
                <button
                    key={i}
                    type="button"
                    onClick={() => onSelect(s)}
                    className="px-2.5 py-1 rounded-full text-[11px] font-medium bg-muted hover:bg-primary/10 hover:text-primary border border-border transition-colors truncate max-w-[160px]"
                    title={`${s.name} (${s.count}x)`}
                >
                    {s.name}
                </button>
            ))}
        </div>
    );
}
